import type {TaillightRenderer} from '@github-ui/taillights/types'
import {createContext} from 'react'

// Private adapter configuration, deliberately not part of the exported viewer API.
export const ExperimentalSourceOptionsContext = createContext<{
  renderer?: TaillightRenderer
  safariCSSHighlighting?: boolean
  virtualized?: boolean
  experimentalReverseSticky?: boolean
  linesPerChunk?: number
  linesToBuffer?: number
}>({})
